import { styled } from "@linaria/react";
import React from "react";
import { color, fonts, radius, zIndex } from "..";
import type { PopperProps } from "../Popper";
import Popper from "../Popper";
import { shadows } from "../Theme";

const UnstyledTooltip = (props: PopperProps) => (
  <Popper
    hover
    keepOpenOnOverlayActive
    gap={5}
    arrowWidth={8}
    openDelay={200}
    closeDelay={300}
    placement="top"
    borderWidth={1}
    borderColor={color.zz_tooltipBorder}
    backgroundColor={color.zz_tooltipBackground}
    color={color.hydrogen}
    {...props}
  />
);

const Tooltip = styled(UnstyledTooltip)`
  max-width: 500px;
  padding: 10px;
  font: ${fonts.body2};
  font-weight: 500;
  z-index: ${zIndex.popper};
  border-radius: ${radius};
  box-shadow: ${shadows.shadow100};
`;

export default React.memo(Tooltip);
